<script lang="ts">
	import type { Page } from '#lib/schema-extension.js';
	import { setAttr } from '@directus/visual-editing';
	import DynamicBlock from './DynamicBlock.svelte';
	import ErrorPage from './ErrorPage.svelte';

	const { page }: { page?: Page } = $props();
</script>

{#if page}
	<div
		class="flex min-w-0 flex-col gap-6"
		data-directus={setAttr({ collection: 'page', item: page.id!!, mode: 'modal' })}
	>
		{#if page.showTitle}
			<h1
				data-directus={setAttr({
					collection: 'page',
					item: page.id!!,
					fields: ['title', 'showTitle'],
					mode: 'popover'
				})}
			>
				{page.title}
			</h1>
		{/if}
		{#if page.blocks}
			<DynamicBlock blocks={page.blocks} />
		{/if}
	</div>
{:else}
	<ErrorPage
		title="404"
		message="Wir konnten diese Seite leider nicht finden. Überprüfe den Link oder gehe zurück zur Startseite"
		buttonLink="/"
		buttonText="Zurück zur Startseite"
	/>
{/if}
